import { SftpSectionConnected } from '@/features/settings/connected'

export default function SettingsSftpPage() {
  return <SftpSectionConnected />
}
